/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Meeting_Delete_TitleInputs */



/**
* | output |
* | --- |
* | "Delete this conversation?" |
*
* @param {Manual_Meeting_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_delete_title = /** @type {((inputs?: Manual_Meeting_Delete_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_Delete_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dit gesprek verwijderen?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer cette conversation ?")
	return /** @type {LocalizedString} */ ("Delete this conversation?")
});